import { z } from "zod";
const DepartmentPermissionSchema = z.enum([
  "manage_department",
  "manage_subdivisions",
  "manage_roster",
  "assign_ranks",
  "manage_permissions",
  "approve_transfers",
  "department_admin",
  "manage_training",
  "manage_certifications",
  "grade_training",
  "schedule_training",
  "manage_department_content",
  "manage_announcements",
]);

export const DepartmentApplicationRoleSettingsSchema = z.object({
  viewerRoleIds: z.array(z.string().regex(/^\d{17,20}$/)).max(100),
  managerRoleIds: z.array(z.string().regex(/^\d{17,20}$/)).max(100),
});
export type DepartmentApplicationRoleSettings = z.infer<
  typeof DepartmentApplicationRoleSettingsSchema
>;

export const DepartmentApplicationWebhookSchema = z.object({
  id: z.number().int(),
  label: z.string(),
});
export type DepartmentApplicationWebhook = z.infer<typeof DepartmentApplicationWebhookSchema>;

export const CreateDepartmentApplicationWebhookSchema = z.object({
  label: z.string().trim().min(1).max(100),
  url: z
    .string()
    .max(512)
    .regex(/^https:\/\/discord(?:app)?\.com\/api\/webhooks\/\d{17,20}\/[A-Za-z0-9_-]{20,200}$/),
});

export const DepartmentManualMemberSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  discordUsername: z.string().nullable(),
  role: z.string(),
  lastPortalLoginAt: z.string().nullable(),
  grants: z.array(
    z.object({
      id: z.number().int(),
      departmentId: z.number().int(),
      departmentName: z.string(),
      permission: DepartmentPermissionSchema,
      expiresAt: z.string().nullable(),
    }),
  ),
});
export type DepartmentManualMember = z.infer<typeof DepartmentManualMemberSchema>;

export const ReplaceManualDepartmentPermissionsSchema = z.object({
  permissions: z.array(DepartmentPermissionSchema).max(30),
  expiresAt: z.string().datetime().nullable().optional(),
});

export const DepartmentApplicationReviewSchema = z.object({
  status: z.enum(["approved", "denied"]),
  reviewNote: z.string().trim().max(2000).nullable().optional(),
});

export const DepartmentPromotionHoldSchema = z.object({
  memberId: z.number().int(),
  memberName: z.string().nullable(),
  departmentId: z.number().int().nullable(),
  departmentName: z.string(),
  daId: z.number().int(),
  actionTaken: z.string(),
  startDate: z.string(),
  expiryDate: z.string(),
  active: z.boolean(),
});
